:host {
  display: block;
  --tambr-snackbar-position: 15px;
}


.tambr-snackbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
  background-color: #333;
  color: #fff;
  padding: 10px 10px 10px 15px;
  z-index: 1000;
  min-width: 200px;
  max-width: 400px;
  display: flex;
  gap: 10px;
  border-radius: 5px;
}

.tambr-snackbar.success {
  background-color: var(--tambr-snackbar-success-bg-color,  var(--tambr-accent-color) );
}

.tambr-snackbar.error {
  background-color: var(--tambr-snackbar-error-bg-color, #f44336);
}

.tambr-snackbar.warning {
  background-color: var(--tambr-snackbar-warning-bg-color, #ff9800);
}

.tambr-snackbar.info {
  background-color: var(--tambr-snackbar-info-bg-color, #2196F3);
}

.tambr-snackbar.top-left {
  top: var(--tambr-snackbar-position);
  bottom: auto;
  left: var(--tambr-snackbar-position);
  right: auto;
}

.tambr-snackbar.top-right {
  top: var(--tambr-snackbar-position);
  bottom: auto;
  left: auto;
  right: var(--tambr-snackbar-position);
}

.tambr-snackbar.bottom-left {
  top: auto;
  bottom: var(--tambr-snackbar-position);
  left: var(--tambr-snackbar-position);
  right: auto;
}

.tambr-snackbar.bottom-right {
  top: auto;
  bottom: var(--tambr-snackbar-position);
  left: auto;
  right: var(--tambr-snackbar-position);
}

.tambr-snackbar .message {
  flex: 1;
  display: flex;
  align-items: center;
}

.tambr-snackbar .message span {
  padding-right: 5px;
}

.tambr-snackbar .close {
  cursor: pointer;
  flex-shrink: 0;
}

.tambr-snackbar .close tambr-icon {
  display: block;
  fill: #fff;
  transition: fill 0.1s;
}

.tambr-snackbar .close:hover tambr-icon {
  fill: #efefef;
}

.tambr-snackbar .action-button {
  text-decoration: underline;
  cursor: pointer;
}

.tambr-snackbar .action-button:hover {
  opacity: 0.9;
}